export default "__VITE_ASSET__BUfdUKGz__"